import React from 'react';

export function BottomNav({ items, active, onChange }) {
  // Show max 5 items on mobile, prioritise key screens
  const visible = items.filter(i => i.section !== 'account').slice(0, 5);

  return (
    <nav className="bot-nav">
      {visible.map(item => (
        <button
          key={item.id}
          className={`bot-nav-item${active === item.id ? ' active' : ''}`}
          onClick={() => onChange(item.id)}
        >
          <span className="bn-icon">{item.icon}</span>
          <span className="bn-label">{item.label}</span>
          {item.badge ? <span className="bot-nav-badge">{item.badge}</span> : null}
        </button>
      ))}
    </nav>
  );
}
